export enum Positions {
   TOP = 'TOP',
   RIGHT = 'RIGHT',
   BOTTOM = 'BOTTOM',
   LEFT = 'LEFT',
   NONE = 'NONE',
}